import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { trainingTypeData } from "../../core/data/json/trainingTypeData";
import Table from "../../core/common/dataTable/index";
import TrainingTypeModal from "../../core/modals/trainingTypeModal";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {
  fetchAlltrainingtype,
  updatetrainingtype,
  deletetrainingtypeById,
} from "../../core/data/redux/training/trainertype/trainertypeAction";
import Select from "react-select";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { Drawer, message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { decryptData } from "../../core/utils/encryptUtils";

const TrainingType = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { training, loading } = useSelector((state: any) => state.training.trainingType);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [isEditing, setIsEditing] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [iseditDrawerVisible, setIseditDrawerVisible] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const trainingtypeId = selectedRowData?.TrainingKey;
  const [errors, setErrors] = useState<any>({});
  const [formData, setFormData] = useState<any>({
    Name: "",
    Description: "",
    Status: "",
    Id: "",
  });

  const { trainingType } = useSelector((state: any) => state.training);
  useEffect(() => {
    dispatch(fetchAlltrainingtype());
  }, []);

  const handleDelete = (trainingtypeId: any) => {
    const id = trainingtypeId;
    dispatch(deletetrainingtypeById({ id }))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          dispatch(fetchAlltrainingtype());
          setTableKey((prevKey) => prevKey + 1);
        } else {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleEdit = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);
    const selectedStatus =
      statusOptions.find((option) => option.value === record.Status) || null;
    setFormData({
      Name: record.Type || "",
      Description: record.Description || "",
      Status: selectedStatus,
      Id: record.TrainingKey,
    });
  };

  useEffect(() => {
    if (selectedRowData) {
      const selectedStatus =
        statusOptions.find(
          (option) => option.value === selectedRowData.Status
        ) || null;

      setFormData({
        Name: selectedRowData.Type || "",
        Description: selectedRowData.Description || "",
        Status: selectedStatus,
        Id: selectedRowData.TrainingKey || "",
      });
    }
  }, [selectedRowData]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");

  const validateForm = () => {
    let formIsValid = true;
    let newErrors: any = {
      Name: "",
      Description: "",
      Status: "",
    };

    if (!formData.Name.trim()) {
      formIsValid = false;
      newErrors.Name = "Name is required.";
    }



    if (!formData.Status || formData.Status.value === "Select") {
      formIsValid = false;
      newErrors.Status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (isEditing) {
      const id = trainingtypeId;
      const updatedData = {
        ...formData,
        Status: formData.Status?.value || "",
        modifiedBy: user.UserId,
      };
      dispatch(updatetrainingtype({ id, data: updatedData })).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success("Training Type Updated Successfully");
          setIseditDrawerVisible(false);
          dispatch(fetchAlltrainingtype())
        } else {
          message.warning(res.payload.error);
        }
      });
    }
  };

  const routes = all_routes;
  const data = trainingType ? trainingType.trainingtype : [];

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { Status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "Created_at",
      "Created_at",
      selectedSort
    );
  }, [dispatch, trainingType, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, trainingType, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, trainingType]);

  const statusOptions = [
    { value: "Select", label: "Select" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];
  const columns = [
    {
      title: "Type",
      dataIndex: "Type",
      render: (text: string) => <Link to="#">{text}</Link>,
      sorter: (a: any, b: any) => a.Type.length - b.Type.length,
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a: any, b: any) => a.Description.length - b.Description.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => {
        const badgeClass =
          text.toLowerCase() === "active"
            ? "badge-success"
            : text.toLowerCase() === "inactive"
              ? "badge-danger"
              : "badge-secondary";

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}
          </span>
        );
      },
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link to="#" data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Edit">
            <i
              className="ti ti-edit"
              onClick={() => {
                if (canEdit) {
                  setIsEditing(true);
                  handleEdit(record);
                  setIseditDrawerVisible(true);
                }
              }}
              style={{
                pointerEvents: canEdit ? "auto" : "none",
                cursor: canEdit ? "pointer" : "not-allowed",
                opacity: canEdit ? 1 : 0.5,
              }}
            />
          </Link>
          <Link to="#" data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete">
            <i
              className="ti ti-trash"
              onClick={() => {
                if (canDelete && record.Status !== "inactive") {
                  setSelectedRowData(record);
                  setIsDeleteModalVisible(true);
                }
              }}
              style={{
                pointerEvents:
                  canDelete && record.Status !== "inactive" ? "auto" : "none",
                cursor:
                  canDelete && record.Status !== "inactive"
                    ? "pointer"
                    : "not-allowed",
                opacity: canDelete && record.Status !== "inactive" ? 1 : 0.5,
              }}
            />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Training Type</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Training</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Training Type
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <button
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => {
                      setFormData({
                        Name: "",
                        Description: "",
                        Status: { value: "Select", label: "Select" },
                        Id: "",
                      });
                      setIsEditing(false);
                      setIsDrawerVisible(true);
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Training Type
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Training Type List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <TrainingTypeModal
        visible={isDrawerVisible}
        onClose={() => setIsDrawerVisible(false)}
      />

      <Drawer
        title="Edit Training Type"
        placement="right"
        onClose={() => setIseditDrawerVisible(false)}
        open={iseditDrawerVisible}
        width={480}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                  />
                  {errors.Name && (
                    <div style={{ color: "red" }}>{errors.Name}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger"> *</span>
                  </label>
                  <Select
                    className="select"
                    options={statusOptions}
                    value={formData.Status}
                    onChange={(selectedOption: any) =>
                      setFormData({ ...formData, Status: selectedOption })
                    }
                  />
                  {errors.Status && (
                    <div style={{ color: "red", marginTop: 4 }}>
                      {errors.Status}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    name="Description"
                    value={formData.Description}
                    onChange={handleChange}
                  />
                  {errors.Description && (
                    <div style={{ color: "red" }}>{errors.Description}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setIseditDrawerVisible(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Save...
                </>
              ) : (
                'Update Changes'
              )}
            </button>

          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => trainingtypeId && handleDelete(trainingtypeId)}
      />
    </>
  );
};

export default TrainingType;
